<template lang="pug">
  .box-search
    h4 {{ condition.name }}
    span.label 求人検索条件{{ index + 1}}
    ul
      li
        span 掲載メディア
        | {{ condition.media | normalize }}
      li
        span 所在地
        | {{ condition.prefectures | normalize }}
        br
        | {{ condition.cities | normalize }}
      li
        span 勤務地
        | {{ condition.workPlacePrefectures | normalize }}
        br
        | {{ condition.workPlaceCities | normalize }}
      li
        span 業種
        | {{ condition.industries | normalize }}
      li
        span キーワードその他
        | {{ condition.condition.keyword | normalize }}
      li
        span 除外キーワード
        | {{ condition.condition.excludeKeyword | normalize }}
    p.buttons
      input.button-main(type="button", value="検索", @click.prevent="search")
    .box-mylist-delete
      a(@click.prevent="destroy") 削除する
    .box-notification-setting
      form(@submit.prevent="update")
        span.label メール通知設定
        span.updated 更新日 : {{ condition.updatedAt }}
        ul
          li
            span
              | 通知曜日
            label.checkbox
              input(type='checkbox' v-model="monday" true-value="true" false-value="false")
              span 月
            label.checkbox
              input(type='checkbox' v-model="tuesday" true-value="true" false-value="false")
              span 火
            label.checkbox
              input(type='checkbox' v-model="wednesday" true-value="true" false-value="false")
              span 水
            label.checkbox
              input(type='checkbox' v-model="thursday" true-value="true" false-value="false")
              span 木
            label.checkbox
              input(type='checkbox' v-model="friday" true-value="true" false-value="false")
              span 金
            label.checkbox
              input(type='checkbox' v-model="saturday" true-value="true" false-value="false")
              span 土
            label.checkbox
              input(type='checkbox' v-model="sunday" true-value="true" false-value="false")
              span 日
          li
            span 通知時間
            select(v-model="hour")
              option(v-for="option in hourItems" :value="option") {{ option }}
            | ：
            select(v-model="minutes")
              option(v-for="option in minutesItems" :value="option") {{ option }}
          li
            span 新着件数
            label.text
              input.lower-limit-count-input(
                type="text"
                v-model="lowerLimitCount"
                placeholder="半角数字のみ")
              | 件以上の求人が集まったとき
              p ※10,000件まで設定可能です
        p.buttons
          input.button-main(type="submit" value="設定更新" v-bind:disabled="disabledSubmit()")
</template>

<script>
  import { mapGetters } from 'vuex'
  import { HumanInfoMessages, DefaultOrder, DefaultOrderDirection } from '../../constants'

  const splitter = '、'
  const placeHolder = '-'
  const maxHour = 24
  const hourRange = [...Array(maxHour).keys()]


  export default {
    props: ['condition', 'index'],
    data () {
      return {
        name: this.condition.name,
        monday: this.condition.monday,
        tuesday: this.condition.tuesday,
        wednesday: this.condition.wednesday,
        thursday: this.condition.thursday,
        friday: this.condition.friday,
        saturday: this.condition.saturday,
        sunday: this.condition.sunday,
        minutes: this.toMinutesString(this.condition.time.getMinutes()),
        hour: this.condition.time.getHours(),
        lowerLimitCount: this.condition.lowerLimitCount,
        hourItems: hourRange,
        minutesItems: ['00', '15', '30', '45'],
      }
    },
    computed: {
      ...mapGetters('searchCondition', ['builtQuery']),
      id () {
        return this.condition.id
      },
    },
    methods: {
      search () {
        const query = this.condition.condition
        const apiQuery = {
                         mediaCd: query.mediaCd.map(m => (m.value || m)).join(','),
                         prefectureCd: query.prefectureCd.map(p => (p.value || p)).join(','),
                         cityCd: query.cityCd.map(p => (p.value || p)).join(','),
                         workPlacePrefectureCd: query.workPlacePrefectureCd === undefined ? '' : query.workPlacePrefectureCd.map(p => (p.value || p)).join(','),
                         workPlaceCityCd: query.workPlaceCityCd === undefined ? '' : query.workPlaceCityCd.map(p => (p.value || p)).join(','),
                         stationKeyword: query.stationKeyword,
                         jobtypeCd: query.jobtypeCd.map(t => (t.value || t)).join(','),
                         industryCd: query.industryCd.map(i => (i.value || i)).join(','),
                         viewEndDate: query.viewEndDate,
                         acquisitionDate: query.acquisitionDate,
                         selectedIntroductionCompany: query.selectedIntroductionCompany,
                         excludedTemporaryStaffing: query.excludedTemporaryStaffing,
                         excludedNoCompanyTel: query.excludedNoCompanyTel,
                         excludedNoCompanyUrl: query.excludedNoCompanyUrl,
                         prPointCd: query.prPointCd.map(pp => (pp.value || pp)).join(','),
                         salaryCd: query.salaryCd,
                         salaryMin: query.salaryMin,
                         salaryMax: query.salaryMax,
                         employmentCd: query.employmentCd.map(ec => (ec.value || ec)).join(','),
                         budgetLower: query.budgetLower,
                         budgetUpper: query.budgetUpper,
                         companyName: query.companyName,
                         hakenCompanyName: query.hakenCompanyName,
                         companyId: query.companyId,
                         stationId: query.stationId,
                         keyword: query.keyword === undefined ? '' : query.keyword.map(i => (i.value || i)).join(','),
                         excludeKeyword: query.excludeKeyword === undefined ? '' : query.excludeKeyword.map(i => (i.value || i)).join(','),
                         order: DefaultOrder,
                         orderDirection: DefaultOrderDirection,
                         fromAcquisitionDate: query.fromAcquisitionDate,
                         toAcquisitionDate: query.toAcquisitionDate,
                       }
        this.$router.push({
          name: query.haken ? 'SearchHaken' : 'SearchJob',
          query: apiQuery,
        })
      },
      toObjects (ids) {
        if (!ids) {
          return []
        }

        return ids.split(',').reduce((list, id) => {
          list.push(id)
          return list
        }, [])
      },
      toMinutesString (minutes) {
        if (minutes === 0) {
          return '00'
        }
        return minutes
      },
      async destroy () {
        // eslint-disable-next-line
        if (!confirm(HumanInfoMessages.DO_DESTROY_JOB_NOTIFICATION_SETTING.replace('%s', this.condition.name))) {
          return
        }

        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('jobNotificationSetting/destroy', { id: this.id })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.JOB_NOTIFICATION_SETTING_DESTROYED })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      async update () {
        this.$store.commit('common/lockGlobal')
        try {
          this.$store.dispatch('jobNotificationSetting/send', {
                                                                id: this.id,
                                                                monday: this.monday,
                                                                tuesday: this.tuesday,
                                                                wednesday: this.wednesday,
                                                                thursday: this.thursday,
                                                                friday: this.friday,
                                                                saturday: this.saturday,
                                                                sunday: this.sunday,
                                                                hour: this.hour,
                                                                minutes: this.minutes,
                                                                lowerLimitCount: this.lowerLimitCount,
                                                              })
          this.$store.dispatch('common/pushToastInfo', { info: HumanInfoMessages.DO_UPDATE_JOB_NOTIFICATION_SETTING })
        } catch (e) {
          this.$store.dispatch('common/pushToastError', { error: e })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      disabledSubmit () {
        if ((this.monday !== 'true' && this.monday !== true &&
             this.tuesday !== 'true' && this.tuesday !== true &&
             this.wednesday !== 'true' && this.wednesday !== true &&
             this.thursday !== 'true' && this.thursday !== true &&
             this.friday !== 'true' && this.friday !== true &&
             this.saturday !== 'true' && this.saturday !== true &&
             this.sunday !== 'true' && this.sunday !== true) ||
            this.lowerLimitCount === '' ||
            this.lowerLimitCount > 10000 ||
            this.lowerLimitCount.toString().match(/[^A-Za-z0-9]+/) !== null) {
          return true
        }

        return false
      },
    },
    filters: {
      normalize (v) {
        if (Array.isArray(v)) {
          if (v.length) {
            return v.length > 20
              ? `${v.slice(0, 20).join(splitter)} 他`
              : v.join(splitter)
          }
          return placeHolder
        }

        return v || placeHolder
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobNotificationSetting.vue